import { State } from "@chq/enrollment-api";

export const useNonConsentStates = (): State[] => {
  return [State.CA, State.SC];
};
